export const hookLogFactory = (hookId: string) => {
  const hookLog = (first: unknown, ...args: unknown[]) => {
    console.debug(`Hook Log:\n${hookId}\n\n`, first, ...args);
  };
  return hookLog;
};
